import { Controller } from 'stimulus';
import throttle from '../helpers/throttle';
import dataLayer from '../tracking/dataLayer';
import { loadVideoJs, loadVideoCSS } from '../helpers/videoLibrary';

const VIDEO_THRESHOLDS = [25, 50, 75, 100];

class Video extends Controller {
  connect() {
    this.player = null;

    this.thresholds = VIDEO_THRESHOLDS.slice();

    this.videoElement = this.element.firstElementChild;

    this.provider = this.videoElement.getAttribute('data-plyr-provider');
    this.embedId = this.videoElement.getAttribute('data-plyr-embed-id');
    this.autoplay = this.videoElement.getAttribute('data-autoplay') === 'true';

    this.throttledTimeUpdate = throttle(this.onTimeUpdate.bind(this), 1000);

    loadVideoJs().then((module) => {
      loadVideoCSS().then(() => {
        const Plyr = module.default;

        this.player = new Plyr(this.videoElement, {
          muted: this.autoplay,
        });

        if (this.videoElement.dataset.cloak) {
          this.player.elements.container.style.opacity = 0;
        }

        this.eventListeners();
      });
    });
  }

  eventListeners() {
    this.player.on('timeupdate', this.throttledTimeUpdate);

    this.player.on('play', () => {
      dataLayer.event('video', 'play', `${this.provider}:${this.embedId}`);
    });

    this.player.on('ready', () => {
      this.player.elements.container.style.opacity = 1;

      if (this.autoplay) {
        this.player.play();
      }
    });
  }

  onTimeUpdate(event) {
    const { currentTime, duration } = event.detail.plyr;
    const currentThreshold = (currentTime / duration) * 100;

    this.thresholds.forEach((threshold) => {
      const index = this.thresholds.indexOf(threshold);

      if (currentThreshold >= threshold) {
        this.thresholds.splice(index, 1);

        const label = `${this.provider}:${this.embedId}`;

        dataLayer.event('video', `threshold_${threshold}`, label);
      }
    });
  }
}

Video.targets = [
  'container',
];

export default Video;
